export const ZALAMO_MAGNET_PRODUCT_ID = 'cmlxw6hs3000235aqp7eqcy1g';
export const ZALAMO_MAGNET_FORMAT_ATTRIBUTE_ID = 'cmlxw8hxu000435aqd39jp3ww';

export const ZALAMO_MAGNET_DEFAULT_PAPER_CONFIGURATION = {
  cmly6mjbc000335aqupd9i5ro: 'cmly6midu000235aqao19xkzu',
} as const;
export const ZALAMO_MAGNET_FORMATS = [
  {
    sizeId: '10x15',
    graphqlSize: 's10x15',
    optionId: 'cmlxw8hey000335aqyw26fiug',
    label: '10x15',
    pricePln: 8,
    widthMm: 100,
    heightMm: 150,
    artworkScale: 1,
  },
  {
    sizeId: '6.67x10',
    graphqlSize: 's6_67x10',
    optionId: 'cmuch3n6e0000ekt7hyhigmzp',
    label: '7x10',
    pricePln: 7,
    widthMm: 100 * (2 / 3),
    heightMm: 100,
    artworkScale: 2 / 3,
  },
] as const;

export type ZalamoMagnetFormat = typeof ZALAMO_MAGNET_FORMATS[number];
export type ZalamoMagnetSizeId = ZalamoMagnetFormat['sizeId'];

export function findZalamoMagnetFormatBySize(
  sizeId: string,
): ZalamoMagnetFormat | undefined {
  return ZALAMO_MAGNET_FORMATS.find((format) => format.sizeId === sizeId);
}

export function findZalamoMagnetFormatByOptionId(
  optionId: string,
): ZalamoMagnetFormat | undefined {
  return ZALAMO_MAGNET_FORMATS.find((format) => format.optionId === optionId);
}

export function getZalamoMagnetFormatFromConfiguration(
  configuration: string,
): ZalamoMagnetFormat {
  let parsedConfiguration: unknown;
  try {
    parsedConfiguration = JSON.parse(configuration);
  } catch {
    throw new Error('Invalid Zalamo magnet configuration');
  }
  if (
    !parsedConfiguration ||
    typeof parsedConfiguration !== 'object' ||
    Array.isArray(parsedConfiguration)
  ) {
    throw new Error('Invalid Zalamo magnet configuration');
  }

  const optionId = (parsedConfiguration as Record<string, unknown>)[
    ZALAMO_MAGNET_FORMAT_ATTRIBUTE_ID
  ];
  const format =
    typeof optionId === 'string'
      ? findZalamoMagnetFormatByOptionId(optionId)
      : undefined;
  if (!format) {
    throw new Error('Unsupported Zalamo magnet format: ' + String(optionId));
  }
  return format;
}

export function getZalamoMagnetConfiguration(
  sizeId: string,
): Record<string, string> {
  const format = findZalamoMagnetFormatBySize(sizeId);
  if (!format) {
    throw new Error(`Unsupported Zalamo Print magnet size: ${sizeId}`);
  }
  return { [ZALAMO_MAGNET_FORMAT_ATTRIBUTE_ID]: format.optionId };
}
